<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-stepper v-model="e1">
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1" step="1"> Your Customization </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="2"> Preview </v-stepper-step>
        </v-stepper-header>
        <v-stepper-items id="content-canvas">
          <v-stepper-content step="1">
            <div class="mb-3" style="border-bottom: 1px solid silver;">
              <v-btn @click="refresh" color="green" class="mr-2">Refresh</v-btn>
              <label title="Add a background" class="myFile2 mb-3 d-inline-block"
                ><span class="pointer btn-upload"> Upload Preview Image </span>&nbsp;
                <input ref="fileUploader" @change="uploadImageProduct" type="file" id="file2" />
              </label>
              <v-btn class="ml-2" @click="addText('product')" v-if="hasImageObject"
                ><v-icon> mdi-format-text</v-icon> Add Text</v-btn
              >
              <v-btn class="ml-2" @click="addImage('product')" v-if="hasImageObject"
                ><v-icon> mdi-file-image</v-icon> Add Image</v-btn
              >
            </div>
            <v-row class="flex mb-3">
              <v-col cols="4" class="scroll-setting">
                <SelectionStyle
                  v-if="showCustomizeWindow"
                  :isChangeOption="isChangeOption"
                  :fonts="fonts"
                  @addText="addText('product')"
                  @addImage="addImage('product')"
                  @deleteSelection="deleteSelection('product')"
                  @updateData="getDataStyle"
                  @loadFont="getFontPersonalize"
                  :data="optionsProductSetting"
                  :type="'product'"
                />
              </v-col>
              <v-col cols="7" class="product-canvas d-flex justify-center align-center">
                <canvas id="cp" width="0px" height="0px"></canvas>
              </v-col>
            </v-row>
            <v-btn color="primary" @click="stepSetupProduct"> Continue </v-btn>
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-row no-gutters>
              <v-col cols="12" class="product-canvas d-flex justify-center align-center">
                <div class="personalize-production"></div>
              </v-col>
            </v-row>
            <v-row no-gutters class="my-3">
              <v-btn :loading="isLoading" @click="submit" elevation="" color="primary"> Save </v-btn>
              <v-btn class="ml-5" text @click="e1 = 1"> Back </v-btn>
            </v-row>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-col>
    <v-overlay :value="overlay">
      <div class="fz-18">
        <v-progress-circular :size="30" color="primary" indeterminate></v-progress-circular>
      </div>
    </v-overlay>
    <canvas id="c1" width="1" height="1"></canvas>
  </v-row>
</template>

<script>
import { fabric } from 'fabric';
import $ from 'jquery';
import SelectionStyle from './components/SelectionStyle.vue';
import logic from './logic-personal';

export default {
  components: { SelectionStyle },
  mixins: [logic],
  async mounted() {
    this.maxWidth = $('#content-canvas').width() - 30;
    this.canvas.product = new fabric.Canvas('cp', {
      hoverCursor: 'pointer',
      selection: true,
      selectionBorderColor: 'blue',
    });
    this.loadFCV = new fabric.Canvas('c1');
    await this.getFontPersonalize();
    this.previewSetting.product = new fabric.Canvas('cpp');
    let vm = this;
    this.canvas.product.on('mouse:down', function(opt) {
      let target = opt.target;
      if (target) {
        if (target.custom?.type === 'textbox') {
          vm.showCustomizeWindow = true;
          vm.optionsProductSetting.text = target.text;
          vm.optionsProductSetting.align = target.textAlign;
          vm.optionsProductSetting.fontFamily = target.fontFamily;
          vm.optionsProductSetting.bold = target.fontWeight && target.fontWeight === 'bold' ? true : false;
          vm.optionsProductSetting.fontStyle = target.fontStyle && target.fontStyle === 'italic' ? true : false;
          vm.optionsProductSetting.fontColor = target.fill;
          vm.optionsProductSetting.effect = target.effect;
          vm.optionsProductSetting.underline = target.underline;
          vm.optionsProductSetting.fontSize = `${target.fontSize}px`;
          vm.optionsProductSetting.caps = target.styles === 'uppercase' ? true : false;

          vm.optionsProductSetting.maxLength = target.maxLength;
          vm.optionsProductSetting.required = target.custom.required;
          vm.optionsProductSetting.placeholder = target.custom.placeholder;
          vm.optionsProductSetting.bodyHtml = target.custom.bodyHtml;
          vm.optionsProductSetting.validations = target.custom.validations;
          vm.windowTitle = 'Text Customize';
        } else if (target.custom?.type === 'image') {
          vm.showCustomizeWindow = true;
          vm.windowTitle = 'Image Customize';
        } else {
          vm.showCustomizeWindow = false;
        }
        vm.$forceUpdate();
      } else {
        vm.showCustomizeWindow = false;
      }
    });
  },
  methods: {},
};
</script>

<style lang="scss">
.myFile {
  position: relative;
  overflow: hidden;
  float: left;
  clear: left;
}

.myFile input[type='file'] {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0;
  font-size: 30px;
  filter: alpha(opacity=0);
}

.myFile2 input[type='file'] {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0;
  font-size: 30px;
  filter: alpha(opacity=0);
}
.myFile2 {
  .btn-upload {
    background: #1f739e;
    font-weight: bold;
    color: white;
    padding: 8px 8px;
    display: flex;
    align-items: center;
    border-radius: 4px;
  }
}
.scroll-setting {
  overflow-y: auto;
  height: 600px;
}
.scroll-setting::-webkit-scrollbar {
  width: 8px;
}
.scroll-setting::-webkit-scrollbar-track {
  background: #8a8889;
  border-radius: 10px;
}
.scroll-setting::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.5);
  border-radius: 10px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.5);
}
</style>
